import { TableCell, TableHead as TableHeadMUI, TableRow, TableSortLabel } from '@mui/material'
import { HelperWrapper } from 'src/components/helper-wrapper'
import { ETranslationNs } from 'src/types'

interface IProps {
  handleSortChange: (sortName: string) => () => void
  activeSort: string
  sortDirection: 'desc' | 'asc'
  isScaner: boolean
}

export const TableHead = ({ handleSortChange, activeSort, sortDirection, isScaner }: IProps) => {
  return (
    <TableHeadMUI>
      <TableRow>
        <TableCell align="center" />
        <TableCell align="center">
          <TableSortLabel
            onClick={handleSortChange('scan.status')}
            active={activeSort === 'scan.status'}
            direction={sortDirection}
            sx={{
              marginLeft: '20px',
            }}
          >
            <HelperWrapper ns={ETranslationNs.Scans} t="status-table-column" />
          </TableSortLabel>
        </TableCell>
        <TableCell align="center">
          <TableSortLabel
            onClick={handleSortChange('scan.record_type')}
            active={activeSort === 'scan.record_type'}
            direction={sortDirection}
            sx={{
              marginLeft: '20px',
            }}
          >
            <HelperWrapper ns={ETranslationNs.Scans} t="scan-type-table-column" />
          </TableSortLabel>
        </TableCell>
        <TableCell>
          <TableSortLabel
            onClick={handleSortChange('scanner.email')}
            active={activeSort === 'scanner.email'}
            direction={sortDirection}
          >
            <HelperWrapper ns={ETranslationNs.Scans} t="scan-user-table-column" />
          </TableSortLabel>
        </TableCell>
        <TableCell align="center">
          <TableSortLabel
            onClick={handleSortChange('account.account_holder')}
            active={activeSort === 'account.account_holder'}
            direction={sortDirection}
            sx={{
              marginLeft: '20px',
            }}
          >
            <HelperWrapper ns={ETranslationNs.Scans} t="scan-account-table-column" />
          </TableSortLabel>
        </TableCell>
        <TableCell align="center">
          <TableSortLabel
            onClick={handleSortChange('product.name')}
            active={activeSort === 'product.name'}
            direction={sortDirection}
            sx={{
              marginLeft: '20px',
            }}
          >
            <HelperWrapper ns={ETranslationNs.Scans} t="scan-product-table-column" />
          </TableSortLabel>
        </TableCell>
        <TableCell>
          <TableSortLabel
            onClick={handleSortChange('step.name')}
            active={activeSort === 'step.name'}
            direction={sortDirection}
          >
            <HelperWrapper ns={ETranslationNs.Scans} t="scan-step-table-column" />
          </TableSortLabel>
        </TableCell>
        <TableCell align="center">
          <TableSortLabel
            onClick={handleSortChange('scan.created_at')}
            active={activeSort === 'scan.created_at'}
            direction={sortDirection}
            sx={{
              marginLeft: '20px',
            }}
          >
            <HelperWrapper t="table-created-column" />
          </TableSortLabel>
        </TableCell>
        <TableCell align="center">
          <HelperWrapper t="actions-label" />
        </TableCell>
      </TableRow>
    </TableHeadMUI>
  )
}
